const toggleOOSItems = (e) => {
  const toggleButton = document.querySelector(
    '.thb-filter-availability input[name="filter.v.availability"]'
  );
  if (toggleButton) {
    toggleButton.click();
  }
};

setInterval(() => {
  const url = new URLSearchParams(window.location.search);
  // Code by Ruby - Convx - #3304 TL-3514 - avoid error msg show up
  // if (url.has("filter.v.availability")) {
  //   document.getElementById("hideOOS").checked = true;
  // }
  const checkbox = document.getElementById("hideOOS");
  if (url.has("filter.v.availability") && checkbox) {
    checkbox.checked = true;
  }
  // End of #3304 TL-3514

  const facetRemove = document.querySelector("facet-remove");
  if (facetRemove) {
    const facetCount = facetRemove.children.length;
    const firstChildIsInStock =
      facetRemove.children[0]?.textContent.trim().toLowerCase() ===
        "in stock" || false;

    if (facetCount === 2 && firstChildIsInStock) {
      facetRemove.style.display = "none";
    } else {
      facetRemove.style.display = "";

      if (firstChildIsInStock) {
        facetRemove.children[0].style.display = "none";
      }
    }
  }
}, 1000);

document.addEventListener('DOMContentLoaded', () => {
  
  function addProductToCart(variantId, store, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ]
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      if (callback) callback(store); 
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  function updateCartAttributes(store) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Selected Store': store
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart attributes updated:', data);
    
      setTimeout(() => {
        window.location.href = '/checkout';
      }, 1000); 
    })
    .catch(error => {
      console.error('Error updating cart attributes:', error);
    });
  }

  function showPopup(message) {
    const popup = document.getElementById('popup-modal');
    const popupMessage = document.getElementById('popup-message');
    popupMessage.textContent = message;
    popup.style.display = 'block';
  }

  function hidePopup() {
    const popup = document.getElementById('popup-modal');
    popup.style.display = 'none';
  }

  // Function to handle the proceed button click
  function handleProceedButtonClick(button) {
    const selectedStore = document.querySelector('input[name="select_store_location"]:checked').value;
    console.log("selectedStore", selectedStore);
    const variantId = button.getAttribute('data-id'); // Use the passed element

    console.log("variantId", variantId);

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items.length === 0) {
          addProductToCart(variantId, selectedStore, updateCartAttributes);
        } else {
          showPopup('Only one product is allowed in the cart. Please remove the existing product before adding a new one.');
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  // // Initial setup
  // setTimeout(function() {
  //   const proceedpickupButton = document.getElementById('proceed-pickup');

  //   if (proceedpickupButton) {
  //     console.log('clicked');
  //     proceedpickupButton.addEventListener('click', handleProceedButtonClick);
  //   }
  // }, 3000);

  $(document).on('click', '#proceed-pickup', function(event) {
    event.preventDefault();
    handleProceedButtonClick(this);
  });

  const popupClose = document.getElementById('popup-close');
  const popupOk = document.getElementById('popup-ok');

  if (popupClose) {
    popupClose.addEventListener('click', hidePopup);
  }

  if (popupOk) {
    popupOk.addEventListener('click', hidePopup);
  }

});

// Convx - #3301 TL-3472
// Cart Revamp Changes made:
// 1. stock-alert-message
// 2. points-message
document.addEventListener('DOMContentLoaded', () => {
  const calculatePoints = () => {
    const cartItems = document.querySelectorAll('[data-product-id]');
    let totalForPoints = 0;

    cartItems.forEach(item => {
      // Get collections information
      const collections = (item.getAttribute('data-product-collections') || '').split(',');

      // Check if item is in sales collection
      const isSalesItem = collections.some(collection =>
        collection.toLowerCase().trim() === 'sale' ||
        collection.toLowerCase().trim() === 'sales'
      );

      // Get price information - directly from the amount span
      const subtotalElement = item.querySelector('.product-subtotal');
      const priceText = subtotalElement.querySelector('.amount').textContent;
      // Convert RM XX.XX to cents (multiply by 100 to handle decimals properly)
      const priceAmount = parseFloat(priceText.replace(/[^0-9.-]+/g, '')) * 100;

      // Debug log for each item
      // console.log(`Product in cart:`, {
      //     collections: collections,
      //     isSalesItem: isSalesItem,
      //     price: priceAmount / 100, // Convert back to RM for logging
      //     includedInPoints: !isSalesItem
      // });

      // Only add to points calculation if not in sales collection
      if (!isSalesItem) {
        totalForPoints += priceAmount;
      }
    });

    // Calculate points (2000 = $20 = 1 point)
    return Math.ceil(totalForPoints / 2000);
  };

  // Function to update points message
  const updatePointsMessage = () => {
    const pointsMessage = document.querySelector('[data-points-message]');
    if (!pointsMessage) return;

    const points = calculatePoints();
    const customerLoggedIn = document.body.classList.contains('customer-logged-in');

    if (customerLoggedIn) {
      pointsMessage.innerHTML = `You will earn <b style="font-weight: bolder;">RM${points}</b> in this purchase!`;
      pointsMessage.style.display = 'block';
    }
  };

  const toggleFeatures = () => {
    // Toggle stock alerts
    const stockAlerts = document.querySelectorAll('[data-stock-alert]');
    stockAlerts.forEach(alert => {
      alert.style.display = 'flex';
    });

    // Update points message
    updatePointsMessage();
  };

  toggleFeatures();

  // Debounce function to limit how often we update
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // Debounced version of toggleFeatures
  const debouncedToggleFeatures = debounce(toggleFeatures, 250);

  // Watch for specific cart updates
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;

    mutations.forEach((mutation) => {
      // Only trigger on price/quantity changes or item removals
      if (mutation.target.classList.contains('product-subtotal') ||
        mutation.target.classList.contains('quantity') ||
        mutation.removedNodes.length > 0) {
        shouldUpdate = true;
      }
    });

    if (shouldUpdate) {
      debouncedToggleFeatures();
    }
  });


  // Start observing cart form for specific changes
  const cartForm = document.querySelector('.thb-cart-form');
  if (cartForm) {
    observer.observe(cartForm, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  // Also update on cart:updated event
  document.addEventListener('cart:updated', debouncedToggleFeatures);
});
// End of #3301 TL-3472